import { styled as a, CircularProgress as e } from "@mui/material";
import { jsx as l } from "react/jsx-runtime";
const i = a(e)`
  color: rgba(255, 255, 255, 0.7);
`, g = (r) => {
  const {
    className: o,
    loading: s,
    size: t = 40
  } = r;
  return s ? /* @__PURE__ */ l(i, {
    size: t,
    className: o
  }) : null;
};
export {
  g as default
};
//# sourceMappingURL=MuiLoading.js.map
